import React, { type Ref } from 'react';
import { motion } from 'framer-motion';

import {
  OPEN_MENU_ANIMATION_DURATION_IN,
  OPEN_MENU_ANIMATION_DURATION_OUT,
  OPEN_MENU_ANIMATION_EASE_IN,
  OPEN_MENU_ANIMATION_EASE_OUT,
} from '../../../config/constants';

export interface DrawerMenuWrapperProps {
  forwardRef: Ref<HTMLDivElement>;
  children: React.ReactNode;
}

const DrawerMenuWrapper: React.FC<DrawerMenuWrapperProps> = (props) => {
  const {
    forwardRef,
    children,
    ...restProps
  } = props;

  return (
    <motion.div
      {...restProps}
      ref={forwardRef}
      initial={{ x: '-100%' }}
      animate={{ x: 0 }}
      transition={{
        duration: OPEN_MENU_ANIMATION_DURATION_IN,
        ease: OPEN_MENU_ANIMATION_EASE_IN,
      }}
      exit={{
        x: 0,
        transition: {
          duration: OPEN_MENU_ANIMATION_DURATION_OUT,
          ease: OPEN_MENU_ANIMATION_EASE_OUT,
        },
      }}
    >
      {children}
    </motion.div>
  );
};

export default DrawerMenuWrapper;
